import { concatMap, MonoTypeOperatorFunction, of, retryWhen, throwError } from 'rxjs';

export const logAndRetry = <T>(message: string): MonoTypeOperatorFunction<T> =>
  retryWhen(errors => errors.pipe(
    concatMap((err: Error, i) => {
      if(i < 3) {
        console.log(`${message} $ error ${err.message} retry #`, i)
        return of()
      } else {
        return throwError(() => err)
      }
    }
  )))
